import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_del_2.png';
import _imports_1 from '@/assets/imgs/ic_del1.png';
import _imports_2 from '@/assets/imgs/ic_add1.png';

const _withScopeId = n => (_pushScopeId("data-v-98dcbe2a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "formTable_container"
};
const _hoisted_5 = {
  class: "table-form"
};
const _hoisted_6 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_7 = ["width"];
const _hoisted_8 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_9 = ["width"];
const _hoisted_10 = {
  class: "action_box"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_14 = {
  class: "footer"
};
import { useI18n } from 'vue-i18n';
import BaseFormItem from './BaseFormItem.vue';
import { serverTypeOptions } from '@/assets/config/dicts';
import { getHostAndPortApi, AddMgCamListApi, getPortByHostApi } from '@/api/live';
import { useCommon } from '@/store/useCommon';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'newCam',
  props: {
    modelValue: {
      default: false,
      type: Boolean
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const snFormRef = ref(null);
    const formDataRef = ref(null);
    const hostSuggestionList = ref([]); //搜索建议

    const portSuggestionList = ref([]);
    const hostList = ref([]);
    const portList = ref([]);
    let resellerType = /reseller/ig.test(window.location.pathname) ? 1 : 0;

    const back = () => {
      emit('update-list');
      emit('update:modelValue', false);
    };

    const validSn = async (rule, value, callback) => {
      if (!value) return callback(new Error(t('请输入SN')));
      if (value.length > 50) return callback(new Error(t('SN的长度应在1到50字符之间')));
      callback();
    };

    const validServerType = (rule, value, callback) => {
      if (value === undefined) return callback(new Error(t('请选择Server Type')));
      callback();
    };

    const validHost = (rule, value, callback) => {
      let dataIndex = rule.field.split('.')[0];
      if (!value || value.length === 0) return callback(new Error(t('请输入Host')));
      if (value.length > 100) return callback(new Error(t('Host的长度应在1到100字符之间')));
      callback();
    }; // 选择搜索建议，查询对应的端口


    const onSelectHost = async ({
      value
    }, i) => {
      loading.value = true;
      let cid = useCommon().userData.cid.length ? useCommon().userData.cid[0] : 0;
      const {
        code,
        data
      } = await getPortByHostApi(value, cid, resellerType);

      if (code == 0) {
        formConfig.formData[i].port = data ? data : '';
      }

      loading.value = false;
    };

    const validPort = (rule, value, callback) => {
      if (!value || value.length === 0) return callback(new Error(t('请输入Port')));
      if (value.length > 50) return callback(new Error(t('Port的长度应在1到50字符之间')));
      callback();
    };

    const validUserName = (rule, value, callback) => {
      if (!value || value.length === 0) return callback(new Error(t('请输入User Name')));
      if (value.length > 100) return callback(new Error(t('User Name的长度应在1到100字符之间')));
      callback();
    };

    const validPwd = (rule, value, callback) => {
      if (!value || value.length === 0) return callback(new Error(t('请输入Password')));
      if (value.length > 100) return callback(new Error(t('Password的长度应在1到100字符之间')));
      callback();
    };

    const validDeskey = (rule, value, callback) => {
      let dataIndex = rule.field.split('.')[0]; // serverType为1时，desKey是必填项

      if (formConfig.formData[dataIndex].serverType == 1 && !value) {
        return callback(new Error(t('请输入Des Key')));
      }

      if (!value) return callback();
      if (value.length > 100) return callback(new Error(t('Des Key的长度应在1到100字符之间')));
      callback();
    };

    const fetchHostSuggest = (queryString, cb) => {
      cb(hostSuggestionList.value);
    };

    const formConfig = reactive({
      snList: [[{
        label: 'SN',
        prop: 'sn',
        widgetType: 'input',
        maxLength: 12,
        colspan: 6,
        required: true,
        rules: {
          validator: validSn,
          trigger: 'blur'
        }
      }]],
      formList: [[{
        label: 'Server Type',
        prop: 'serverType',
        widgetType: 'Select',
        list: serverTypeOptions,
        required: true,
        rules: {
          validator: validServerType,
          trigger: ['blur', 'change']
        }
      }, {
        label: 'Host',
        prop: 'host',
        widgetType: 'autocomplete',
        required: true,
        rules: {
          validator: validHost,
          trigger: ['blur', 'change']
        },
        itemSlot: true // fetchSuggestions: (queryString, cb)=> {
        //   cb(hostSuggestionList.value)
        // },

      }, {
        label: 'TCP Port',
        prop: 'port',
        widgetType: 'input',
        required: true,
        rules: {
          validator: validPort,
          trigger: ['blur', 'change']
        }
      }], [{
        label: 'User Name',
        prop: 'userName',
        widgetType: 'input',
        required: true,
        rules: {
          validator: validUserName,
          trigger: 'blur'
        }
      }, {
        label: 'Password',
        prop: 'password',
        widgetType: 'input',
        required: true,
        rules: {
          validator: validPwd,
          trigger: 'blur'
        }
      }, {
        label: 'DES Key',
        prop: 'desKey',
        widgetType: 'input',
        required: true,
        rules: {
          validator: validDeskey,
          trigger: 'blur'
        },
        itemSlot: true
      }]],
      formData: [{
        sn: '',
        host: '',
        port: '',
        serverType: 0,
        userName: '',
        password: '',
        desKey: '',
        reseller: resellerType,
        operatorId: useCommon().userData.id,
        operatorName: useCommon().userData.name,
        cid: useCommon().userData.cid.length ? useCommon().userData.cid[0] : 0
      }]
    }); //新增

    const onAdd = () => {
      if (formConfig.formData.length === 10) return ElMessage({
        type: 'warning',
        message: t('最多添加十组配置')
      });
      formConfig.formData.push({
        host: '',
        port: '',
        serverType: 0,
        userName: '',
        password: '',
        desKey: '',
        reseller: resellerType,
        sn: formConfig.formData[0].sn,
        operatorId: useCommon().userData.id,
        operatorName: useCommon().userData.name,
        cid: useCommon().userData.cid.length ? useCommon().userData.cid[0] : 0
      });
    }; //删除


    const onDeleteItem = i => {
      formConfig.formData.splice(i, 1);
    }; // 获取host和Port的建议列表


    const getHostAndPort = async operatorId => {
      let cid = useCommon().userData.cid.length ? useCommon().userData.cid[0] : 0;
      const {
        code,
        data
      } = await getHostAndPortApi(operatorId, cid, resellerType);

      if (code == 0) {
        hostList.value = data.hostList;
        hostSuggestionList.value = data.hostList.map((item, index) => {
          return {
            label: item,
            value: item
          };
        });
      }
    };

    const onConfirm = async () => {
      Promise.all([snFormRef.value.validate(), formDataRef.value.validate()]).then(async res => {
        //整理formData参数
        formConfig.formData.forEach((item, index) => {
          if (index != 0) {
            item.sn = formConfig.formData[0].sn;
          }
        });
        const {
          code,
          data
        } = await AddMgCamListApi(formConfig.formData);

        if (code == 0) {
          if (data.length === 0) {
            emit('update:modelValue', false);
            emit('update-list');
          } else {
            //数据重复了，提示一下
            data.forEach(item => {
              ElMessage({
                type: 'warning',
                message: `Host: ${item.host} Port:${item.port} UserName: ${item.userName} ${t('配置已重复，请修改后提交')}`
              });
            });
          }
        }
      }).catch(err => {});
    }; // 监听formData变化，serverType选择CCCam时，对应的desKey置空


    watch(() => formConfig.formData, (newVal, oldVal) => {
      if (newVal) {
        newVal.forEach(item => {
          if (item.serverType == 0) {
            item.desKey = '';
          }
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.modelValue, (newVal, oldVal) => {
      if (newVal) {
        getHostAndPort(useCommon().userData.id);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_autocomplete = _resolveComponent("el-autocomplete");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('添加')), 1), _createVNode(_component_el_button, {
        type: "primary",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
        model: formConfig.formData,
        ref_key: "snFormRef",
        ref: snFormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([1], (item, index) => {
          return _createElementVNode("div", {
            key: index
          }, [_createElementVNode("table", _hoisted_6, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['10%', '21%', '10%', '21%', '10%', '21%', '7%'], c => {
            return _createElementVNode("col", {
              width: c
            }, null, 8, _hoisted_7);
          }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.snList || [], (formItem, formIndex) => {
            return _openBlock(), _createBlock(BaseFormItem, {
              key: formIndex,
              onDeleteItem: _ctx.handleDeleteItem,
              "form-item": formItem,
              "form-data": formConfig.formData[index],
              c_index: index
            }, null, 8, ["onDeleteItem", "form-item", "form-data", "c_index"]);
          }), 128))])])]);
        }), 64))]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_form, {
        model: formConfig.formData,
        ref_key: "formDataRef",
        ref: formDataRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            style: {
              "position": "relative"
            }
          }, [_createElementVNode("table", _hoisted_8, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['10%', '21%', '10%', '21%', '10%', '21%', '7%'], c => {
            return _createElementVNode("col", {
              width: c
            }, null, 8, _hoisted_9);
          }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList || [], (formItem, formIndex) => {
            return _openBlock(), _createBlock(BaseFormItem, {
              key: formIndex,
              onDeleteItem: _ctx.handleDeleteItem,
              "form-item": formItem,
              "form-data": formConfig.formData[index],
              c_index: index
            }, {
              itemSlot: _withCtx(scope => [scope.prop === 'desKey' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: formConfig.formData[index].desKey,
                "onUpdate:modelValue": $event => formConfig.formData[index].desKey = $event,
                disabled: formConfig.formData[index].serverType === 0
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), scope.prop === 'host' ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                key: 1,
                class: "inline-input",
                modelValue: formConfig.formData[index].host,
                "onUpdate:modelValue": $event => formConfig.formData[index].host = $event,
                "fetch-suggestions": fetchHostSuggest,
                onSelect: $event => onSelectHost($event, index)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onSelect"])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["onDeleteItem", "form-item", "form-data", "c_index"]);
          }), 128)), _createElementVNode("div", _hoisted_10, [index === 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "info",
            disabled: "",
            style: {
              "margin-bottom": "1px",
              "width": "36px"
            }
          }, {
            default: _withCtx(() => [_hoisted_11]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            color: "#fdeded",
            onClick: $event => onDeleteItem(index),
            style: {
              "margin-bottom": "1px",
              "width": "36px"
            }
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 2
          }, 1032, ["onClick"])), _createVNode(_component_el_button, {
            color: "#e9f4fc",
            onClick: onAdd,
            style: {
              "margin-bottom": "1px",
              "width": "36px"
            }
          }, {
            default: _withCtx(() => [_hoisted_13]),
            _: 1
          })])])])]);
        }), 128))]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
        type: "default",
        onClick: _cache[0] || (_cache[0] = $event => emit('update:modelValue', false)),
        style: {
          "width": "120px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: onConfirm,
        style: {
          "width": "120px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
        _: 1
      })])])])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true);
    };
  }

});